import { Divider, Input, message, Row, Typography } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { SectionLoader } from "../../../../atoms/SectionLoader/SectionLoader";
import { formatDate } from "../../../../libs/utils";
import { addCommentRequest, AddCommentRequest, fetchCommentsRequest } from "../api";

type CommentsSectionProps = {
  ticketId?: string;
  onSuccess?: () => void;
};

export const CommentsSection = (props: CommentsSectionProps) => {
  const { ticketId, onSuccess } = props;

  const [comments, setComments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [commentText, setCommentText] = useState<string>();

  const handleAddComment = async () => {
    if (!ticketId || !commentText || commentText.trim() === "") return;

    try {
      setIsSubmitting(true);
      const payload: AddCommentRequest = {
        comment: commentText,
        moduleId: ticketId,
        type: "internal",
      };
      await addCommentRequest(payload);
      setCommentText(null);
      await fetchComments();
      onSuccess?.();
    } catch (error) {
      const errorMessage = "Error occurred while adding comment";
      console.error(errorMessage, error);
      message.error(error?.response?.data?.error ?? errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  const fetchComments = useCallback(async () => {
    if (!ticketId) return;
    try {
      setIsLoading(true);

      const response = await fetchCommentsRequest(ticketId);
      setComments(response.result.data);
    } catch (error) {
      const errorMessage = "Error occurred while fetching comment";
      console.error(errorMessage, error);
      message.error(error?.response?.data?.error ?? errorMessage);
    } finally {
      setIsLoading(false);
    }
  }, [ticketId]);

  useEffect(() => {
    fetchComments();
  }, [ticketId]);

  return (
    <Row className="bf-main">
      <Typography.Text>Comments</Typography.Text>
      <Input.Search
        placeholder="Add your comments"
        allowClear
        enterButton="Add"
        onChange={(e) => setCommentText(e.target.value)}
        value={commentText}
        onSearch={handleAddComment}
        loading={isSubmitting}
      />
      <Row style={{ display: "flex", justifyContent: "center", width: "100%", marginTop: "0.5rem" }}>
        <div style={{ maxHeight: "22rem", overflowY: "auto", width: "99%" }}>
          <SectionLoader isLoading={isLoading} containerStyle={{ height: "3rem" }} >
            {comments?.length > 0 &&
              comments.map((comment, idx) => (
                <div key={comment?.ticketCommentId} className="w-100">
                  <p style={{ marginBlock: 10 }}>{comment?.comment}</p>
                  <p style={{ color: "#006791" }}>
                    <span>{formatDate(comment?.createdAt)}</span>
                    <span>{" by "}</span>
                    <span style={{ fontWeight: "bold" }}>{comment?.commentBy?.name}</span>
                  </p>
                  {idx !== comments.length - 1 && <Divider />}
                </div>
              ))}
          </SectionLoader>
        </div>
      </Row>
    </Row>
  );
};
